import { Drawer, IconButton, Stack } from '@ethings/ui-toolkit';
import { Box, styled, Theme, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';

interface Props {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
}

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  position: 'relative',
  zIndex: 1000,
  '& .MuiDrawer-paper': {
    background: theme.palette.background.paper,
    color: theme.palette.getContrastText(theme.palette.background.paper),
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
    boxShadow: theme.shadows[8],
    height: 'min-content !important',
    maxHeight: '80vh',
    overflow: 'hidden',
    '& .MuiFormControlLabel-root.Mui-disabled': {
      color: 'inherit !important',
      opacity: 0.5,
    },
    '& .MuiFormControlLabel-root.Mui-disabled .MuiFormControlLabel-label': {
      color: 'inherit !important',
      WebkitTextFillColor: 'currentColor !important',
    },
    '& .MuiCheckbox-root.Mui-disabled, & .MuiCheckbox-root.Mui-disabled .MuiSvgIcon-root': {
      color: 'inherit !important',
      fill: 'currentColor',
    },
  },
}));

const Puller = styled(Box)(({ theme }: { theme: Theme }) => ({
  backgroundColor: theme.drawer.puller,
  borderRadius: 3,
  display: 'block',
  height: 6,
  left: 'calc(50% - 15px)',
  position: 'absolute',
  top: 8,
  width: 30,
}));

const PullerWrapper = styled(Stack)(() => ({
  boxSizing: 'border-box',
  maxHeight: '80vh',
  overflowX: 'hidden',
  overflowY: 'auto',
  overscrollBehaviorY: 'contain',
  position: 'relative',
  padding: '48px 36px 0',
  WebkitOverflowScrolling: 'touch',
}));

export const LayerMenuMobile: FC<Props> = ({ children, onClose, open }) => {
  const theme = useTheme();
  const { t } = useTranslation(['common']);

  return (
    <StyledDrawer
      anchor="bottom"
      disableEnforceFocus={true}
      onClose={onClose}
      open={open}
    >
      <IconButton
        aria-label={t('common:common.action.close')}
        onClick={onClose}
        size="small"
        style={{ position: 'absolute', right: 16, top: 16, zIndex: 1 }}
      >
        <Icon icon="X" />
      </IconButton>
      <PullerWrapper>
        <Puller theme={theme} />
        {children}
      </PullerWrapper>
    </StyledDrawer>
  );
};
